"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var reselect_1 = require("reselect");
var constants_1 = require("./constants");
var moduleState = function (rootState) { return rootState[constants_1.namespace]; };
// eslint-disable-next-line import/prefer-default-export
exports.isInternetConnected = reselect_1.createSelector(moduleState, function (state) { return state.isInternetConnected; });
exports.internetSource = reselect_1.createSelector(moduleState, function (state) { return state.internetSource; });
//# sourceMappingURL=selectors.js.map